import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ListBulleted = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 4.5625C3.55228 4.5625 4 4.11478 4 3.5625C4 3.01022 3.55228 2.5625 3 2.5625C2.44772 2.5625 2 3.01022 2 3.5625C2 4.11478 2.44772 4.5625 3 4.5625ZM5.49996 3.06252C5.22382 3.06252 4.99996 3.28637 4.99996 3.56252C4.99996 3.83866 5.22382 4.06252 5.49996 4.06252H13.5C13.7761 4.06252 14 3.83866 14 3.56252C14 3.28637 13.7761 3.06252 13.5 3.06252H5.49996ZM3 9C3.55228 9 4 8.55228 4 8C4 7.44772 3.55228 7 3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9ZM5.49996 7.50002C5.22382 7.50002 4.99996 7.72387 4.99996 8.00002C4.99996 8.27616 5.22382 8.50002 5.49996 8.50002H13.5C13.7761 8.50002 14 8.27616 14 8.00002C14 7.72387 13.7761 7.50002 13.5 7.50002H5.49996ZM4 12.438C4 12.9903 3.55228 13.438 3 13.438C2.44772 13.438 2 12.9903 2 12.438C2 11.8857 2.44772 11.438 3 11.438C3.55228 11.438 4 11.8857 4 12.438ZM4.99996 12.438C4.99996 12.1619 5.22382 11.938 5.49996 11.938H13.5C13.7761 11.938 14 12.1619 14 12.438C14 12.7141 13.7761 12.938 13.5 12.938H5.49996C5.22382 12.938 4.99996 12.7141 4.99996 12.438Z"
        />
      </svg>
    )
  },
)

export default ListBulleted
